<div class="group__text">
    <ng-content select=":not(assignment-multiple-choice-option)"></ng-content>
</div>

<ng-content select="assignment-multiple-choice-option"></ng-content>
